import { useEffect } from 'react';
import { useIoContext } from '~/providers/IoContext';
export const ANALYST_INTERCOM_VERTICAL_PADDING = 90;
// WHY: IntercomStarter boots without a vertical_padding, so 20 (Intercom's documented default) is the launcher's pre-feature baseline to restore on unmount.
export const INTERCOM_DEFAULT_VERTICAL_PADDING = 20;
export const useRaiseIntercomLauncher = (isOpen)=>{
    const { intercomClient } = useIoContext();
    useEffect(()=>{
        intercomClient.update({
            vertical_padding: ANALYST_INTERCOM_VERTICAL_PADDING
        });
        return ()=>intercomClient.update({
                vertical_padding: INTERCOM_DEFAULT_VERTICAL_PADDING
            });
    }, [
        intercomClient
    ]);
    useEffect(()=>{
        if (!isOpen) return;
        intercomClient.hideIntercom();
        return ()=>intercomClient.showIntercom();
    }, [
        intercomClient,
        isOpen
    ]);
};
